// Pure gating logic for the coach agent and the dev memory window.
// Centralized here so the policy is named, testable, and only lives in
// one place.

import { AGENT_COACH, AGENT_GUIDE, AGENT_HELP } from "./LLMClient";

// The entitlement that unlocks the coach: the backend's Feature.WORKSPACE,
// which api.py's _is_coach_entitled checks before running a guide request as
// coach (PLEX-6289). It was "v2" until PLEX-6514 renamed it.
export const COACH_FEATURE = "workspace";

// Whether the user may run the coach (PLEX-6523). Read from /me/entitlements
// once it has loaded. Until then a Plex admin counts as entitled, since the
// backend's admin bypass gives them every feature, so an admin's session
// doesn't start as guide and switch.
export const isCoachEntitled = ({ entitlementsStore, isAdmin }) => {
  if (entitlementsStore?.myLoaded) return entitlementsStore.isFeatureEnabled(COACH_FEATURE);
  return Boolean(isAdmin);
};

// An entitled user always gets the coach and anyone else gets guide
// (PLEX-6523), matching _resolve_effective_agent on the backend. There is no
// opt-out: the old Research Coach toggle only changed the UI, while the
// backend answered as coach regardless.
export const resolveSessionAgent = ({ withAutoplex, coachEntitled }) => {
  if (!withAutoplex) return AGENT_HELP;
  return coachEntitled ? AGENT_COACH : AGENT_GUIDE;
};

// The dev memory window only renders when (a) the cell has hindsight
// enabled, (b) the user is an admin, AND (c) the active agent is coach.
// Mirrors the server-side admin gate in plex.search.memory.service.
export const shouldShowMemoryWindow = ({ memoryEnabled, isAdmin, sessionAgent }) =>
  Boolean(memoryEnabled && isAdmin && sessionAgent === AGENT_COACH);

// Visualization canvas shows when: feature enabled AND coach session AND store says it should show.
// canvasShouldShow already encodes "has charts AND not dismissed".
export const shouldShowVizCanvas = ({ vizEnabled, sessionAgent, canvasShouldShow }) =>
  Boolean(vizEnabled && canvasShouldShow && sessionAgent === AGENT_COACH);
